import request from '@/utils/request'

/**
 * 添加供应商批次凭证照片信息(qiuyanping)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function pcSupplierBatchAdd(data) {
  return request({
    type: 'biz',
    url: 'pc/supplier/batch/add',
    method: 'post',
    data
  })
}
/**
 * 批量删除供应商批次信息(cme)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function pcSupplierBatchAllDelete(data) {
  return request({
    type: 'biz',
    url: 'pc/supplier/batch/all/delete',
    method: 'post',
    data
  })
}
/**
 * 删除供应商批次信息(cme)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function pcSupplierBatchDelete(data) {
  return request({
    type: 'biz',
    url: 'pc/supplier/batch/delete',
    method: 'post',
    data
  })
}
/**
 * 获取供应商批次列表(cme)
 * @author: zhangkang
 * @createDate: 2020/12/24
 * @param data {Object} 参数
 */
export function pcSupplierBatchPageListGet(data) {
  return request({
    type: 'biz',
    url: 'pc/supplier/batch/page/list/get',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/SupplierBatchPc.js